import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import { SanitizeHtml, buildThumbnailUrl } from '@bd/bdcore-utilities';
import PageHelmet from '@bd/bdcore-pagehelmet';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';
// import PageIntroBanner from '../../components/PageIntroBanner';
// import { colors, typography } from '../../styles';

const styles = css`
  .alternatingBoxes {
    display:flex;
    flex-flow:row wrap;
    justify-content: center;
    margin-bottom:16px;
    @media (min-width: 991px) {
      min-height:400px;
    }

    .alternatingBoxes_Media {
      width:100%;
      border:0;
      background-size:cover;
      background-position: center;
      padding-top:56%;
      @media (min-width: 991px) {
        border-right:8px solid white;
        padding-top:0;
        width:50%;
      }
    }
    .alternatingBoxes_Content {
      width:100%;
      border:0;
      background:whitesmoke;
      padding:30px;
      display: flex;
      flex-flow:column wrap;
      justify-content: center;
      @media (min-width: 991px) {
        padding:60px;
        border-left:8px solid white;
        width:50%;
      }
    }
  }
  .alternatingBoxes:nth-child(even) {
    flex-flow:row-reverse wrap;

    .alternatingBoxes_Media {
      border:0;
      @media (min-width: 991px) {
        border-left:8px solid white;
        padding-top:0;
        width:50%;
      }
    }
    .alternatingBoxes_Content {
      border:0;
      @media (min-width: 991px) {
        border-right:8px solid white;
      }
    }
  }
  main {
    padding-top:60px;
    padding-bottom:40px;
  }
`;

function AboutUs({ page }) {
  return (
    <div className={styles}>
      <PageWrapper>
        <PageHelmet page={page} />
        <InsideHeader
          h1={`${page.meta.name}`}
          background={get(page, 'page_image.contentUrl')}
        />
        {/* <PageIntroBanner
          heading={get(page, 'page_intro_banner[0].heading')}
          body={get(page, 'page_intro_banner[0].text')}
          image={get(page, 'page_intro_banner[0].image.contentUrl')}
        /> */}
        <main className="container">
          {
              page.alternating_sections.map(item => (
                <div key={item.text} className="alternatingBoxes">
                  <div className="alternatingBoxes_Media" style={{ backgroundImage: `linear-gradient(to bottom, rgba(0,0,0,0.25) 0%,rgba(0,0,0,0.25) 100%), url(${buildThumbnailUrl(item.image.contentUrl, { width: 2000, height: 2000, preserve: true })})` }} />
                  <div className="alternatingBoxes_Content" dangerouslySetInnerHTML={SanitizeHtml(get(item, 'text'))} />
                </div>
              ))
            }
        </main>
      </PageWrapper>
    </div>
  );
}

AboutUs.propTypes = {
  page: PropTypes.object.isRequired,
};

export default withData({
  page: 'about_us',
})(AboutUs);



// WEBPACK FOOTER //
// ./src/pages/AboutUs/index.js